
import { mapGetters, mapMutations } from 'vuex'
import noResultsImg from './no-results.svg'
import FilterTag from '~/components/Inventory/FolderTemplate/FolderTemplateHeader/FilterTags/FilterTag/index.vue'
import { isArrayWithLength } from '~/ZenOne-StoryBook/helpers/types'

export default {
  name: 'CatalogNoResults',
  components: { FilterTag },
  data() {
    return {
      noResultsImg
    }
  },
  computed: {
    ...mapGetters({
      tags: 'catalog/filterTags',
      filters: 'catalog/filters',
    })
  },
  methods: {
    ...mapMutations('catalog', {
      setFiltersOnly: 'SET_FILTERS_ONLY',
    }),
    cantFindProductBtnClickHandler() {
      this.$emit('on-show-add-missing-product')
    },
    clearFilters() {
      this.$store.commit('catalog/CLEAR_FILTERS')
      this.$store.commit('search/SET_SEARCH_TERM', '')
    },
    removeFilter({ tag = {} }) {
      let filters = { ...this.filters }
      const filterName = tag.filterName
      const value = filters[filterName]

      if (isArrayWithLength(value)) {
        const set = new Set([...value])
        set.delete(parseInt(tag?.id))
        filters = {
          ...filters,
          [filterName]: [...set],
        }
      } else if (typeof value === 'boolean') {
        filters[filterName] = false
      } else {
        delete filters[filterName]
      }
      this.setFiltersOnly(filters)
    }
  }
}
